// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/diagnostics.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { PageRequest, PageResponse } from "./common_pb.js";

/**
 * @generated from message omnios.v1.DiagnosticsEnrollmentToken
 */
export const DiagnosticsEnrollmentToken = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiagnosticsEnrollmentToken",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "observed_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "token_prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "rollout_ring", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "platform_hint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "expires_at", kind: "message", T: Timestamp },
    { no: 10, name: "claimed_at", kind: "message", T: Timestamp },
    { no: 11, name: "claimed_device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "claimed_hostname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.DiagnosticsDeviceEnrollment
 */
export const DiagnosticsDeviceEnrollment = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiagnosticsDeviceEnrollment",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "observed_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "platform", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "hostname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "rollout_ring", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "certificate_fingerprint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "claimed_at", kind: "message", T: Timestamp },
    { no: 12, name: "enrolled_at", kind: "message", T: Timestamp },
    { no: 13, name: "last_seen_at", kind: "message", T: Timestamp },
    { no: 14, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "created_at", kind: "message", T: Timestamp },
    { no: 16, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.DiagnosticsRecordingPolicy
 */
export const DiagnosticsRecordingPolicy = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiagnosticsRecordingPolicy",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "version", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "capture_profile", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "policy", kind: "message", T: Struct },
    { no: 8, name: "created_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "updated_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.DiagnosticsRecordingSession
 */
export const DiagnosticsRecordingSession = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiagnosticsRecordingSession",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "observed_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "capture_profile", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "policy_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "policy_version", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "started_at", kind: "message", T: Timestamp },
    { no: 11, name: "heartbeat_at", kind: "message", T: Timestamp },
    { no: 12, name: "ended_at", kind: "message", T: Timestamp },
    { no: 13, name: "end_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "bytes_uploaded", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 15, name: "segment_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 16, name: "input_batch_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 17, name: "context_event_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 18, name: "created_at", kind: "message", T: Timestamp },
    { no: 19, name: "updated_at", kind: "message", T: Timestamp },
    { no: 20, name: "timeline_batch_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.DiagnosticsRecordingArtifact
 */
export const DiagnosticsRecordingArtifact = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiagnosticsRecordingArtifact",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "recording_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "artifact_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sequence_no", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "storage_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "storage_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "sha256", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "byte_size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 12, name: "created_at", kind: "message", T: Timestamp },
    { no: 13, name: "stream_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateEnrollmentTokenRequest
 */
export const CreateEnrollmentTokenRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateEnrollmentTokenRequest",
  () => [
    { no: 1, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "observed_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "rollout_ring", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "platform_hint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "expires_in_hours", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateEnrollmentTokenResponse
 */
export const CreateEnrollmentTokenResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateEnrollmentTokenResponse",
  () => [
    { no: 1, name: "token", kind: "message", T: DiagnosticsEnrollmentToken },
    { no: 2, name: "plaintext", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListEnrollmentTokensRequest
 */
export const ListEnrollmentTokensRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEnrollmentTokensRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListEnrollmentTokensResponse
 */
export const ListEnrollmentTokensResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListEnrollmentTokensResponse",
  () => [
    { no: 1, name: "tokens", kind: "message", T: DiagnosticsEnrollmentToken, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListDeviceEnrollmentsRequest
 */
export const ListDeviceEnrollmentsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListDeviceEnrollmentsRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListDeviceEnrollmentsResponse
 */
export const ListDeviceEnrollmentsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListDeviceEnrollmentsResponse",
  () => [
    { no: 1, name: "enrollments", kind: "message", T: DiagnosticsDeviceEnrollment, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ClaimEnrollmentTokenRequest
 */
export const ClaimEnrollmentTokenRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ClaimEnrollmentTokenRequest",
  () => [
    { no: 1, name: "plaintext_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "platform", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "hostname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ClaimEnrollmentTokenResponse
 */
export const ClaimEnrollmentTokenResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ClaimEnrollmentTokenResponse",
  () => [
    { no: 1, name: "enrollment", kind: "message", T: DiagnosticsDeviceEnrollment },
    { no: 2, name: "device_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RegisterDiagnosticsDeviceRequest
 */
export const RegisterDiagnosticsDeviceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RegisterDiagnosticsDeviceRequest",
  () => [
    { no: 1, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "platform", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "hostname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "rollout_ring", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RegisterDiagnosticsDeviceResponse
 */
export const RegisterDiagnosticsDeviceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RegisterDiagnosticsDeviceResponse",
  () => [
    { no: 1, name: "enrollment", kind: "message", T: DiagnosticsDeviceEnrollment },
    { no: 2, name: "device_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpsertRecordingPolicyRequest
 */
export const UpsertRecordingPolicyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpsertRecordingPolicyRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "capture_profile", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "policy", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.UpsertRecordingPolicyResponse
 */
export const UpsertRecordingPolicyResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpsertRecordingPolicyResponse",
  () => [
    { no: 1, name: "policy", kind: "message", T: DiagnosticsRecordingPolicy },
  ],
);

/**
 * @generated from message omnios.v1.ListRecordingPoliciesRequest
 */
export const ListRecordingPoliciesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListRecordingPoliciesRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListRecordingPoliciesResponse
 */
export const ListRecordingPoliciesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListRecordingPoliciesResponse",
  () => [
    { no: 1, name: "policies", kind: "message", T: DiagnosticsRecordingPolicy, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.AssignRecordingPolicyRequest
 */
export const AssignRecordingPolicyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AssignRecordingPolicyRequest",
  () => [
    { no: 1, name: "policy_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "observed_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.AssignRecordingPolicyResponse
 */
export const AssignRecordingPolicyResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AssignRecordingPolicyResponse",
  [],
);

/**
 * @generated from message omnios.v1.GetEffectivePolicyRequest
 */
export const GetEffectivePolicyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEffectivePolicyRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetEffectivePolicyResponse
 */
export const GetEffectivePolicyResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetEffectivePolicyResponse",
  () => [
    { no: 1, name: "policy", kind: "message", T: DiagnosticsRecordingPolicy },
  ],
);

/**
 * @generated from message omnios.v1.StartRecordingSessionRequest
 */
export const StartRecordingSessionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StartRecordingSessionRequest",
  () => [
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "requested_capture_profile", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.StartRecordingSessionResponse
 */
export const StartRecordingSessionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StartRecordingSessionResponse",
  () => [
    { no: 1, name: "session", kind: "message", T: DiagnosticsRecordingSession },
  ],
);

/**
 * @generated from message omnios.v1.ReportRecordingHeartbeatRequest
 */
export const ReportRecordingHeartbeatRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReportRecordingHeartbeatRequest",
  () => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "bytes_uploaded", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "segment_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "input_batch_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "context_event_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "timeline_batch_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.ReportRecordingHeartbeatResponse
 */
export const ReportRecordingHeartbeatResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReportRecordingHeartbeatResponse",
  () => [
    { no: 1, name: "session", kind: "message", T: DiagnosticsRecordingSession },
  ],
);

/**
 * @generated from message omnios.v1.CompleteRecordingSessionRequest
 */
export const CompleteRecordingSessionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CompleteRecordingSessionRequest",
  () => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "end_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CompleteRecordingSessionResponse
 */
export const CompleteRecordingSessionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CompleteRecordingSessionResponse",
  () => [
    { no: 1, name: "session", kind: "message", T: DiagnosticsRecordingSession },
  ],
);

/**
 * @generated from message omnios.v1.UploadRecordingArtifactRequest
 */
export const UploadRecordingArtifactRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UploadRecordingArtifactRequest",
  () => [
    { no: 1, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "artifact_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sequence_no", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "payload", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 7, name: "stream_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "ocr_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UploadRecordingArtifactResponse
 */
export const UploadRecordingArtifactResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UploadRecordingArtifactResponse",
  () => [
    { no: 1, name: "artifact", kind: "message", T: DiagnosticsRecordingArtifact },
  ],
);

/**
 * @generated from message omnios.v1.ListRecordingSessionsRequest
 */
export const ListRecordingSessionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListRecordingSessionsRequest",
  () => [
    { no: 1, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListRecordingSessionsResponse
 */
export const ListRecordingSessionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListRecordingSessionsResponse",
  () => [
    { no: 1, name: "sessions", kind: "message", T: DiagnosticsRecordingSession, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.DiagnosticsTimelineWindow
 */
export const DiagnosticsTimelineWindow = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiagnosticsTimelineWindow",
  () => [
    { no: 1, name: "app_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "window_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "is_focused", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "display_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "captured_at_millis", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.DiagnosticsTimelineSegment
 */
export const DiagnosticsTimelineSegment = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiagnosticsTimelineSegment",
  () => [
    { no: 1, name: "recording_artifact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "recording_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "observed_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "stream_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "sequence_no", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "platform", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "hostname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "capture_started_at", kind: "message", T: Timestamp },
    { no: 11, name: "capture_ended_at", kind: "message", T: Timestamp },
    { no: 12, name: "focused_app_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "focused_window_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "focused_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "app_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 16, name: "windows", kind: "message", T: DiagnosticsTimelineWindow, repeated: true },
    { no: 17, name: "window_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 18, name: "created_at", kind: "message", T: Timestamp },
    { no: 19, name: "ocr_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "ocr_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "ocr_observations_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SearchTimelineSegmentsRequest
 */
export const SearchTimelineSegmentsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchTimelineSegmentsRequest",
  () => [
    { no: 1, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "observed_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "recording_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "app_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "search_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "from_time", kind: "message", T: Timestamp },
    { no: 7, name: "to_time", kind: "message", T: Timestamp },
    { no: 8, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.SearchTimelineSegmentsResponse
 */
export const SearchTimelineSegmentsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchTimelineSegmentsResponse",
  () => [
    { no: 1, name: "segments", kind: "message", T: DiagnosticsTimelineSegment, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.DiagnosticsStorageTarget
 */
export const DiagnosticsStorageTarget = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiagnosticsStorageTarget",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "target_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "target_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "target_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "s3_endpoint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "s3_bucket", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "s3_region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "s3_path_prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "credential_strategy", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "secret_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "assume_role_arn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "broker_base_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "retention_hot_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "retention_warm_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "retention_cold_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "created_at", kind: "message", T: Timestamp },
    { no: 19, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.DiagnosticsReplayRequest
 */
export const DiagnosticsReplayRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiagnosticsReplayRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "requested_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "observed_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "recording_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "replay_scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "investigation_case_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "justification", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "created_at", kind: "message", T: Timestamp },
    { no: 12, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.DiagnosticsExportJob
 */
export const DiagnosticsExportJob = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiagnosticsExportJob",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "requested_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "observed_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "date_from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "date_to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "bundle_prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreateStorageTargetRequest
 */
export const CreateStorageTargetRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateStorageTargetRequest",
  () => [
    { no: 1, name: "target_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "target_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "target_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "s3_endpoint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "s3_bucket", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "s3_region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "s3_path_prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "credential_strategy", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "secret_ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "assume_role_arn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "broker_base_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "retention_hot_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "retention_warm_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "retention_cold_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateStorageTargetResponse
 */
export const CreateStorageTargetResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateStorageTargetResponse",
  () => [
    { no: 1, name: "target", kind: "message", T: DiagnosticsStorageTarget },
  ],
);

/**
 * @generated from message omnios.v1.ListStorageTargetsRequest
 */
export const ListStorageTargetsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListStorageTargetsRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListStorageTargetsResponse
 */
export const ListStorageTargetsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListStorageTargetsResponse",
  () => [
    { no: 1, name: "targets", kind: "message", T: DiagnosticsStorageTarget, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CreateReplayRequestRequest
 */
export const CreateReplayRequestRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateReplayRequestRequest",
  () => [
    { no: 1, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "observed_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "recording_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "replay_scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "justification", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateReplayRequestResponse
 */
export const CreateReplayRequestResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateReplayRequestResponse",
  () => [
    { no: 1, name: "request", kind: "message", T: DiagnosticsReplayRequest },
  ],
);

/**
 * @generated from message omnios.v1.UpdateReplayRequestStatusRequest
 */
export const UpdateReplayRequestStatusRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateReplayRequestStatusRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "investigation_case_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateReplayRequestStatusResponse
 */
export const UpdateReplayRequestStatusResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateReplayRequestStatusResponse",
  () => [
    { no: 1, name: "request", kind: "message", T: DiagnosticsReplayRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListReplayRequestsRequest
 */
export const ListReplayRequestsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListReplayRequestsRequest",
  () => [
    { no: 1, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "recording_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListReplayRequestsResponse
 */
export const ListReplayRequestsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListReplayRequestsResponse",
  () => [
    { no: 1, name: "requests", kind: "message", T: DiagnosticsReplayRequest, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.CreateExportJobRequest
 */
export const CreateExportJobRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateExportJobRequest",
  () => [
    { no: 1, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "observed_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "date_from", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "date_to", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "bundle_prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateExportJobResponse
 */
export const CreateExportJobResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateExportJobResponse",
  () => [
    { no: 1, name: "job", kind: "message", T: DiagnosticsExportJob },
  ],
);

/**
 * @generated from message omnios.v1.ListExportJobsRequest
 */
export const ListExportJobsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListExportJobsRequest",
  () => [
    { no: 1, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListExportJobsResponse
 */
export const ListExportJobsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListExportJobsResponse",
  () => [
    { no: 1, name: "jobs", kind: "message", T: DiagnosticsExportJob, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.HybridSearchRequest
 */
export const HybridSearchRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.HybridSearchRequest",
  () => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "from_time", kind: "message", T: Timestamp },
    { no: 4, name: "to_time", kind: "message", T: Timestamp },
    { no: 5, name: "app_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.HybridSearchResponse
 */
export const HybridSearchResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.HybridSearchResponse",
  () => [
    { no: 1, name: "results", kind: "message", T: SearchResultSegment, repeated: true },
    { no: 2, name: "total_found", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.SearchResultSegment
 */
export const SearchResultSegment = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchResultSegment",
  () => [
    { no: 1, name: "segment", kind: "message", T: DiagnosticsTimelineSegment },
    { no: 2, name: "relevance_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "matched_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.VisualSimilaritySearchRequest
 */
export const VisualSimilaritySearchRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.VisualSimilaritySearchRequest",
  () => [
    { no: 1, name: "reference_artifact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "top_k", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.VisualSimilaritySearchResponse
 */
export const VisualSimilaritySearchResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.VisualSimilaritySearchResponse",
  () => [
    { no: 1, name: "results", kind: "message", T: SearchResultSegment, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetTimeInAppRequest
 */
export const GetTimeInAppRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetTimeInAppRequest",
  () => [
    { no: 1, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.TimeInAppEntry
 */
export const TimeInAppEntry = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TimeInAppEntry",
  () => [
    { no: 1, name: "app_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "duration_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "segment_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "unique_employees", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetTimeInAppResponse
 */
export const GetTimeInAppResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetTimeInAppResponse",
  () => [
    { no: 1, name: "entries", kind: "message", T: TimeInAppEntry, repeated: true },
    { no: 2, name: "total_duration_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "total_apps", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "total_employees", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "total_segments", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetActivityTimelineRequest
 */
export const GetActivityTimelineRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetActivityTimelineRequest",
  () => [
    { no: 1, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ActivityTimelineEntry
 */
export const ActivityTimelineEntry = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ActivityTimelineEntry",
  () => [
    { no: 1, name: "hour", kind: "message", T: Timestamp },
    { no: 2, name: "duration_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "segment_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "unique_apps", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.GetActivityTimelineResponse
 */
export const GetActivityTimelineResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetActivityTimelineResponse",
  () => [
    { no: 1, name: "entries", kind: "message", T: ActivityTimelineEntry, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.NaturalLanguageSearchRequest
 */
export const NaturalLanguageSearchRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.NaturalLanguageSearchRequest",
  () => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.NaturalLanguageSearchResponse
 */
export const NaturalLanguageSearchResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.NaturalLanguageSearchResponse",
  () => [
    { no: 1, name: "results", kind: "message", T: SearchResultSegment, repeated: true },
    { no: 2, name: "total_found", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "parsed_query", kind: "message", T: ParsedSearchQuery },
  ],
);

/**
 * LLM-decomposed structured query
 *
 * @generated from message omnios.v1.ParsedSearchQuery
 */
export const ParsedSearchQuery = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ParsedSearchQuery",
  () => [
    { no: 1, name: "employee_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "app_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text_query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "from_time", kind: "message", T: Timestamp },
    { no: 5, name: "to_time", kind: "message", T: Timestamp },
    { no: 6, name: "intent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetReplaySegmentsRequest
 */
export const GetReplaySegmentsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetReplaySegmentsRequest",
  () => [
    { no: 1, name: "replay_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "message", T: PageRequest },
    { no: 5, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ReplaySegment
 */
export const ReplaySegment = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReplaySegment",
  () => [
    { no: 1, name: "artifact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sequence_no", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "stream_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "capture_started_at", kind: "message", T: Timestamp },
    { no: 6, name: "capture_ended_at", kind: "message", T: Timestamp },
    { no: 7, name: "app_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "window_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "presigned_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "byte_size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "input_events_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "context_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "search_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "ocr_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "visible_apps", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 16, name: "focused_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "is_indexed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "thumbnail_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetReplaySegmentsResponse
 */
export const GetReplaySegmentsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetReplaySegmentsResponse",
  () => [
    { no: 1, name: "segments", kind: "message", T: ReplaySegment, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
    { no: 3, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "replay_scope", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetLiveEmployeesRequest
 */
export const GetLiveEmployeesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetLiveEmployeesRequest",
  [],
);

/**
 * @generated from message omnios.v1.LiveEmployee
 */
export const LiveEmployee = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.LiveEmployee",
  () => [
    { no: 1, name: "employee_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "device_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "capture_profile", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "activity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "bytes_uploaded", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "segment_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "last_event", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.GetLiveEmployeesResponse
 */
export const GetLiveEmployeesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetLiveEmployeesResponse",
  () => [
    { no: 1, name: "employees", kind: "message", T: LiveEmployee, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetDiagnosticsHealthRequest
 */
export const GetDiagnosticsHealthRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetDiagnosticsHealthRequest",
  [],
);

/**
 * @generated from message omnios.v1.DiagnosticsHealthStats
 */
export const DiagnosticsHealthStats = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiagnosticsHealthStats",
  () => [
    { no: 1, name: "active_sessions", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "sessions_started", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "sessions_completed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "total_bytes_uploaded", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "total_segments", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "last_heartbeat_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.GetDiagnosticsHealthResponse
 */
export const GetDiagnosticsHealthResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetDiagnosticsHealthResponse",
  () => [
    { no: 1, name: "stats", kind: "message", T: DiagnosticsHealthStats },
  ],
);

/**
 * @generated from message omnios.v1.RunBatchEmbeddingRequest
 */
export const RunBatchEmbeddingRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RunBatchEmbeddingRequest",
  () => [
    { no: 1, name: "embedding_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "batch_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "max_segments", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.RunBatchEmbeddingResponse
 */
export const RunBatchEmbeddingResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RunBatchEmbeddingResponse",
  () => [
    { no: 1, name: "total_pending", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "processed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "failed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "duration_seconds", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "endpoint_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * One aggregated activity block: a contiguous run of observations
 * the VLM grouped into a single named activity.
 *
 * @generated from message omnios.v1.DiagnosticsActivitySegment
 */
export const DiagnosticsActivitySegment = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiagnosticsActivitySegment",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "recording_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "started_at", kind: "message", T: Timestamp },
    { no: 4, name: "completed_at", kind: "message", T: Timestamp },
    { no: 5, name: "is_open", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "summary", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "observation_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "aggregator_model", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "created_at", kind: "message", T: Timestamp },
    { no: 12, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * One per-frame description from the vision-language model.
 *
 * @generated from message omnios.v1.DiagnosticsActivityObservation
 */
export const DiagnosticsActivityObservation = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiagnosticsActivityObservation",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "recording_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "timeline_segment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "captured_at", kind: "message", T: Timestamp },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "model", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "model_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * Pipeline progress for one session — useful for ops dashboards.
 *
 * @generated from message omnios.v1.DiagnosticsSegmentationCursor
 */
export const DiagnosticsSegmentationCursor = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DiagnosticsSegmentationCursor",
  () => [
    { no: 1, name: "recording_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "last_described_sequence", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "last_aggregated_at", kind: "message", T: Timestamp },
    { no: 5, name: "last_run_at", kind: "message", T: Timestamp },
    { no: 6, name: "attempts", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "last_error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListWorkspaceActivityRequest
 */
export const ListWorkspaceActivityRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListWorkspaceActivityRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListWorkspaceActivityResponse
 */
export const ListWorkspaceActivityResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListWorkspaceActivityResponse",
  () => [
    { no: 1, name: "segments", kind: "message", T: DiagnosticsActivitySegment, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.ListActivitySegmentsRequest
 */
export const ListActivitySegmentsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListActivitySegmentsRequest",
  () => [
    { no: 1, name: "recording_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "started_after", kind: "message", T: Timestamp },
    { no: 3, name: "ended_before", kind: "message", T: Timestamp },
    { no: 4, name: "page", kind: "message", T: PageRequest },
    { no: 5, name: "with_observations", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ObservationBucket
 */
export const ObservationBucket = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ObservationBucket",
  () => [
    { no: 1, name: "observations", kind: "message", T: DiagnosticsActivityObservation, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListActivitySegmentsResponse
 */
export const ListActivitySegmentsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListActivitySegmentsResponse",
  () => [
    { no: 1, name: "segments", kind: "message", T: DiagnosticsActivitySegment, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
    { no: 3, name: "observations_per_segment", kind: "message", T: ObservationBucket, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ReaggregateSessionRequest
 */
export const ReaggregateSessionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReaggregateSessionRequest",
  () => [
    { no: 1, name: "recording_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ReaggregateSessionResponse
 */
export const ReaggregateSessionResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ReaggregateSessionResponse",
  () => [
    { no: 1, name: "segments_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.ResetSegmentationCursorRequest
 */
export const ResetSegmentationCursorRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ResetSegmentationCursorRequest",
  () => [
    { no: 1, name: "recording_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rewind", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ResetSegmentationCursorResponse
 */
export const ResetSegmentationCursorResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ResetSegmentationCursorResponse",
  [],
);

/**
 * @generated from message omnios.v1.ListActivityObservationsRequest
 */
export const ListActivityObservationsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListActivityObservationsRequest",
  () => [
    { no: 1, name: "recording_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "captured_after", kind: "message", T: Timestamp },
    { no: 3, name: "captured_before", kind: "message", T: Timestamp },
    { no: 4, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListActivityObservationsResponse
 */
export const ListActivityObservationsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListActivityObservationsResponse",
  () => [
    { no: 1, name: "observations", kind: "message", T: DiagnosticsActivityObservation, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.GetSegmentationCursorRequest
 */
export const GetSegmentationCursorRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetSegmentationCursorRequest",
  () => [
    { no: 1, name: "recording_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetSegmentationCursorResponse
 */
export const GetSegmentationCursorResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetSegmentationCursorResponse",
  () => [
    { no: 1, name: "cursor", kind: "message", T: DiagnosticsSegmentationCursor },
  ],
);

